import { render, staticRenderFns } from "./MessageEditorButtons.vue?vue&type=template&id=37f4403f&scoped=true&"
import script from "./MessageEditorButtons.vue?vue&type=script&lang=js&"
export * from "./MessageEditorButtons.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorButtons.vue?vue&type=style&index=0&id=37f4403f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4403f",
  null
  
)

export default component.exports